import React, { useState } from 'react';
import Box from "@mui/material/Box";
import MaterialVendors from './material_vendors';
import LabourWork from './labour_work';
import "../../styles.css";

const VendorsList = ({ accessLevel }) => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box>
      {/* Mobile: segmented pills */}
      <Box sx={{ display: { xs: "block", md: "none" }, mb: "12px" }}>
        <div className="arcdx-v-pills">
          {["Material Vendors", "Labour Work"].map((label, i) => (
            <div
              key={label}
              className={`arcdx-v-pill${tabValue === i ? " active" : ""}`}
              onClick={() => setTabValue(i)}
            >
              {label}
            </div>
          ))}
        </div>
      </Box>

      {/* Desktop: premium segmented control (same tabValue) */}
      <Box
        sx={{
          display: { xs: "none", md: "inline-flex" },
          gap: "4px",
          background: "#f2f4f7",
          borderRadius: "13px",
          p: "4px",
          marginBottom: "20px",
        }}
      >
        {["Material Vendors", "Labour Work"].map((label, idx) => {
          const active = tabValue === idx;
          return (
            <Box
              key={label}
              onClick={() => setTabValue(idx)}
              sx={{
                px: 2.25,
                py: "8px",
                borderRadius: "10px",
                fontSize: "13px",
                fontWeight: active ? 700 : 600,
                fontFamily: "Roboto, Arial, sans-serif",
                color: active ? "#1565C0" : "#667085",
                background: active ? "#ffffff" : "transparent",
                boxShadow: active ? "0 1px 3px rgba(16,24,40,0.10)" : "none",
                cursor: "pointer",
                transition: "all 0.2s ease",
                userSelect: "none",
                whiteSpace: "nowrap",
                "&:hover": { color: "#1565C0" },
              }}
            >
              {label}
            </Box>
          );
        })}
      </Box>

      {/* Tab Content */}
      <Box>
        {tabValue === 0 && <MaterialVendors accessLevel={accessLevel} />}
        {tabValue === 1 && <LabourWork accessLevel={accessLevel} />}
      </Box>
    </Box>
  );
};

export default VendorsList;
